const STATUS_LABELS: Record<string, string> = {
	elicitingRequirements: "Gathering requirements",
	approvedRequirements: "Requirements approved",
	requestChanges: "Changes requested",
};

export function humanizePortalStatus(status: string) {
	return (
		STATUS_LABELS[status] ??
		status
			.replace(/([a-z0-9])([A-Z])/g, "$1 $2")
			.replace(/[_-]+/g, " ")
			.replace(/^./, (letter) => letter.toUpperCase())
	);
}

export function needsFundingReasonLabel(reason: "noOrganization" | "noKey" | "providerRefused") {
	return {
		noOrganization: "No active organization is funding this project.",
		noKey: "The organization has no inference key or workspace credential override.",
		providerRefused: "The provider refused the credential or available funding.",
	}[reason];
}
